import request from '@/utils/request'

/**
 * 
 * 做自己节接口
 * openXjy  代表请求open.xjy.cn域名
 */
// 商品列表（分页）
export function productList(data) {
  return request({
    url: '/router/product/list',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 商品列表(不分页)
export function productAll(data) {
  return request({
    url: '/router/product/all',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}



// 商品详情
export function productGet(data) {
  return request({
    url: '/router/product/get',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 商品已购订单
export function orderBuyList(data) {
  return request({
    url: '/router/order/buyList',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 检查优惠码
export function checkCoupon(data) {
  return request({
    url: '/router/pay/checkCoupon',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 创建订单
export function createOrder(data) {
  return request({
    url: '/router/pay/createOrder',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 保存用户信息
export function saveInfo(data) {
  return request({
    url: '/router/pay/saveInfo',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 更新剩余名额
export function cancelOrder(data) {
  return request({
    url: '/router/pay/cancelOrder',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 获取已购买
export function orderGet(data) {
  return request({
    url: '/router/order/get',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 事件统计
export function evenAdd(data) {
  return request({
    url: '/router/event/add',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 获取订单
export function orderList(data) {
  return request({
    url: '/router/order/list',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 获取微信用户信息
export function userInfo(data) {
  return request({
    url: '/router/weixin/userInfo',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}